import {
    queryLikeQuestionList,
    queryLikeQuestionSetList,
    queryLikeStatistic,
    querySatisfactionTrend,
    queryDislikeHistogram,
} from "@/views/zhiji/js/services/service.js";

const defaultLikeStatistic = {
    feedback: {
        num: 0,
        user: 0,
        rate: 0,
    },
    like: {
        num: 0,
        rate: 0,
    },
    question: {
        num: 0,
        user: 0,
    }
};

export default {
    state: {
        likeStatistic: defaultLikeStatistic,
        satisfactionTrend: [],
        dislikeHistogram: [],
        filter: {
            language: "all",
            questionType: "all",
            channel: "all",
            setId: null,
        },
        dates: [],
        channelTable: {
            page: 1,
            size: 10,
            count: 0,
            list: [],
        },
        faqTable: {
            page: 1,
            size: 10,
            count: 0,
            list: [],
        },
        praiseLog: {
            filter: {
                logType: "like_log", // 赞踩日志
                questionType: "all",
                searchType: "all",
                clickId: "all",
            }
        },
    },
    mutations: {
        updateLikeSatis(state, { type, data }) {
            state[type] = data;
        },
        updatelikeSatisfFilter(state, { type, data }) {
            state.filter[type] = data;
        },
        updateLikeDates(state, data) {
            state.dates = data;
        },
        updateLikeStatistic(state, data) {
            state.likeStatistic = data;
        },
        updateLikeChannelTable(state, { type, data }) {
            state.channelTable[type] = data;
        },
        updateLikeFaqTable(state, { type, data }) {
            state.faqTable[type] = data;
        },
        updateSatisfactionTrend(state, data) {
            state.satisfactionTrend = data;
        },
        updateDislikeHistogram(state, data) {
            state.dislikeHistogram = data;
        },
        resetLikePage(state) {
            state.channelTable.page = 1;
            state.faqTable.page = 1;
        },
        resetLike(state) {
            state.likeStatistic = defaultLikeStatistic;
            state.satisfactionTrend = [];
            state.dislikeHistogram = [];
            state.filter = {
                language: "all",
                questionType: "all",
                channel: "all",
                setId: null,
            };
            state.dates = [];
            state.channelTable = {
                page: 1,
                size: 10,
                count: 0,
                list: [],
            };
            state.faqTable = {
                page: 1,
                size: 10,
                count: 0,
                list: [],
            };
            state.praiseLog = {
                filter: {
                    logType: "like_log", // 赞踩日志
                    questionType: "all",
                    searchType: "all",
                    clickId: "all",
                }
            };
        },
    },
    actions: {
        // 获取赞踩数据总览数据
        queryLikeStatistic(context) {
            const { filter, dates } = context.state;
            const newParams = {
                channel: filter.channel,
                questionType: filter.questionType,
                language: filter.language,
                setId: filter.setId,
                ...dates,
            }
            // 获取赞踩数据总览数据
            queryLikeStatistic(newParams).then(function(data) {
                context.commit("updateLikeStatistic", data);
            });
        },
        // 获取【全部FAQ问题】赞踩列表
        queryLikeQuestion(context, props = {}) {
            const { filter, faqTable, dates } = context.state;
            const newParams = {
                channel: filter.channel,
                questionType: filter.questionType,
                language: filter.language,
                setId: filter.setId,
                page: faqTable.page,
                size: faqTable.size,
                ...dates,
                ...props,
            };
            // 获取【全部FAQ问题】赞踩列表
            queryLikeQuestionList(newParams).then(function(res) {
                const { count, list } = res;
                context.commit("updateLikeSatis", {
                    type: "faqTable",
                    data: {
                        page: faqTable.page,
                        size: faqTable.size,
                        count,
                        list,
                    }
                });
            });
        },
        // 获取【全部子场景】赞踩列表
        queryLikeQuestionSet(context, props = {}) {
            const { filter, channelTable, dates } = context.state;
            const newParams = {
                channel: filter.channel,
                questionType: filter.questionType,
                language: filter.language,
                setId: filter.setId,
                page: channelTable.page,
                size: channelTable.size,
                ...dates,
                ...props,
            };
            // 获取【全部FAQ问题】赞踩列表
            queryLikeQuestionSetList(newParams).then(function(res) {
                const { count, list } = res;
                context.commit("updateLikeSatis", {
                    type: "channelTable",
                    data: {
                        page: channelTable.page,
                        size: channelTable.size,
                        count,
                        list,
                    }
                });
            });
        },
        querySatisfactionTrend(context, params) {
            const { filter, dates } = context.state;
            const newParams = {
                channel: filter.channel,
                questionType: filter.questionType,
                language: filter.language,
                setId: filter.setId,
                ...dates,
            };
            querySatisfactionTrend(newParams).then(function(data) {
                context.commit("updateSatisfactionTrend", data);
            })
        },
        queryDislikeHistogram(context, params) {
            const { filter, dates } = context.state;
            const newParams = {
                channel: filter.channel,
                questionType: filter.questionType,
                language: filter.language,
                setId: filter.setId,
                ...dates,
            };
            queryDislikeHistogram(newParams).then(function(data) {
                context.commit("updateDislikeHistogram", data);
            })
        }
    }
}
